import { useCallback, useMemo, useEffect, useState } from "react";

import useAuthContext from "client/hooks/useAuthContext";
import useNotification from "client/hooks/useNotification";
import * as authApi from "client/services/auth";
import { AuthResponseStatusEnum } from "client/services/auth/enums/auth-response-status.enum";

import { LoginParamsType } from "../types/login-params.type";
import { TempAuthType } from "../types/temp-auth.type";
// import { saveAccessToken } from "client/utils/local-storage";
import { AuthResponse } from "client/pages/Login/types/login-response.type";
import Cookies from "js-cookie";
type LoginStatusType = AuthResponseStatusEnum | null;

type LoginType = {
  loading: boolean;
  login: (params: LoginParamsType) => void;
  status: LoginStatusType;
  tempAuth: TempAuthType;
};

export const useLogin = (): LoginType => {
  const [loading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<LoginStatusType>(null);
  const [tempAuth, setTempAuth] = useState<TempAuthType>({} as TempAuthType);
  const { setError, resetErrorCode } = useNotification();
  const { setUserContextByToken } = useAuthContext();

  useEffect(() => {
    return () => setLoading(false);
  }, []);

  const login = useCallback(
    async (params: LoginParamsType) => {
      try {
        setLoading(true);

        const res: AuthResponse = await authApi.login(params);

        const { status, data } = res.data;

        if (status === AuthResponseStatusEnum.Ok) {
          if (data) {
            localStorage.setItem("access_token", data.accessToken);
            Cookies.set("access_token", data.accessToken, {
              expires: 7,
            });
          }
          // saveAccessToken(data.accessToken);
          resetErrorCode(0);
          await setUserContextByToken(data.accessToken);
        }

        if (status === AuthResponseStatusEnum.NewPasswordRequired) {
          const { email, password } = params;
          setTempAuth({ email, tempPass: password });
        }

        setStatus(status);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    },
    [setError, resetErrorCode, setUserContextByToken]
  );

  return useMemo(
    () => ({
      loading,
      status,
      tempAuth,
      login,
    }),
    [loading, status, tempAuth, login]
  );
};
